import { API_BASE_URL } from "../config/config";
import axios from "axios";
import Cookies from "js-cookie";

const CBMToken = async (uid) => {
        //ask txshield to get the token for the user from cbm

        let options = { headers: { Authorization: "Bearer " + Cookies.get("access_token") } };

        const cbmtoken = await axios
            .get(API_BASE_URL + "/v3/user/" + uid + "/getCBMToken", options)
            .then(({ data }) => {
                if (data.token) return data.token.token;
                else console.log(data);
            })
            .catch((error) => {
                console.log(error);
                return false;
            });
        return cbmtoken;
};
export default CBMToken;
